module.exports = __webpack_public_path__ + "static/media/franchising-small-placeholder.639ef1dd.webp";